import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function FinancialDisclaimer() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="disclaimer-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">Financial Disclaimer</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="prose-invert space-y-6 text-zinc-300 text-sm leading-relaxed">
          <div className="card-dark p-6 border-[#F7931A]/30">
            <p className="text-white font-bold text-base mb-3">Bitcoin Brain is not a financial advisor.</p>
            <p>
              All content on Bitcoin Brain — including the 21-section course, weekly briefs, rabbit hole articles, AI assistant responses, quizzes, and any other material — is provided for <strong className="text-white">educational, evangelical, and entertainment purposes only</strong>.
            </p>
          </div>

          <Section title="Not Financial Advice">
            Nothing on Bitcoin Brain constitutes financial advice, investment advice, trading advice, or any other kind of professional advice. Do not make financial decisions based solely on content from this platform. Always do your own research and consult a qualified financial advisor before making investment decisions.
          </Section>

          <Section title="No Investment Recommendations">
            Bitcoin Brain does not recommend buying, selling, or holding Bitcoin or any other asset. The platform teaches Bitcoin concepts and history. Any mention of price, market trends, or future possibilities is educational context, not a recommendation.
          </Section>

          <Section title="BTC XP Has No Monetary Value">
            BTC XP is a gamification feature designed to make learning engaging. It mirrors Bitcoin's appreciation as a teaching tool. BTC XP cannot be exchanged, transferred, sold, or redeemed for Bitcoin, US dollars, or any other currency or asset. It has zero monetary value.
          </Section>

          <Section title="Price Data">
            Bitcoin price data displayed on the platform is sourced from public APIs (CoinGecko, CoinCap, Blockchain.info, Mempool.space) and may be delayed or inaccurate. Do not rely on price data from Bitcoin Brain for trading or investment decisions.
          </Section>

          <Section title="Brain Trust">
            Individuals featured in the Brain Trust section have not endorsed Bitcoin Brain and are not affiliated with this platform. Their public quotes and commentary are attributed for educational purposes only. Their inclusion does not imply endorsement of Bitcoin Brain or any financial strategy.
          </Section>

          <Section title="Risk Acknowledgment">
            Bitcoin is a volatile, high-risk asset. Its price can drop significantly. Past performance does not guarantee future results. You could lose some or all of your investment. By using Bitcoin Brain, you acknowledge that you understand these risks and take full responsibility for your own financial decisions.
          </Section>

          <Section title="Your Responsibility">
            By using Bitcoin Brain, you agree that Bryce Fields and Bitcoin Brain are not responsible for any financial losses, missed opportunities, or damages resulting from your use of this platform or any decisions influenced by its content.
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-white font-heading font-bold text-base mb-2">{title}</h2>
      <p>{children}</p>
    </div>
  );
}
